import { Box, Typography, useTheme, useMediaQuery, Alert, Collapse, IconButton } from '@mui/material';
import { ResourceListItem } from '../../../types';
import React, { useState } from 'react';
import { SimpleList } from '../../../components/SimpleList';
import { useTranslation } from 'react-i18next';
import { translateToolName, translateUOM } from '../../../i18n/utils';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const ResourcesList = ({ items, isUnverified, defaultCollapsed = false }: { items: ResourceListItem[], isUnverified?: boolean, defaultCollapsed?: boolean }) => {
	const nonToolItems = items.filter(item => !item.isTool);
	const toolItems = items.filter(item => item.isTool);
	const [isExpanded, setIsExpanded] = useState(!defaultCollapsed);
	const theme = useTheme();
	const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
	const { t } = useTranslation();

	return (
		<Box sx={{
			minWidth: isSmUp ? '350px' : '300px',
			maxWidth: '350px',
			flex: isSmUp ? '1 0 350px' : '1 0 300px',
		}}>
			<Box display="flex" gap={1} alignItems="center" sx={{ mb: 2 }}>
				{items.length > 0 ? <Typography variant="h6">
					{t('planViewMaterialsCard.materials')}
					{` (${items.length})`}
				</Typography> : <Typography variant="h6">
					{t('planViewMaterialsCard.materials')}
				</Typography>}
				<IconButton onClick={() => setIsExpanded(!isExpanded)}>
					{isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
				</IconButton>
			</Box>
			
			<Collapse in={isExpanded}>
				{items.length === 0 && <Typography variant='body2'>{t('planViewMaterialsCard.noMaterials')}</Typography>}
				{items.length > 0 && isUnverified && <Alert severity='warning'>
					{t('planViewMaterialsCard.unverifiedDisclaimer')}
				</Alert>}
			
				{nonToolItems.length > 0 && <SimpleList items={nonToolItems.map(item => ({
					label: item.name,
					properties: [{
						label: `${item.quantity}`,
						secondary: translateUOM(item.uom)
					}],
					secondary: item.description
				}))} />}
				{toolItems.length > 0 && (
					<>
						<Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
							{t('planViewMaterialsCard.tools')}
						</Typography>
						<SimpleList items={toolItems.map(item => ({
							label: item.isTool ? translateToolName(item.name, item.name) : item.name,
							properties: Number(item.quantity) > 1 ? [{
								label: `${item.quantity}`,
								secondary: translateUOM(item.uom)
							}] : [],
							secondary: item.description,
							additionalInfo: item.isHeavyTool ? <Alert severity='warning'>
								{t('planViewMaterialsCard.heavyTool')}
							</Alert> : null
						}))} />
					</>
				)}
			</Collapse>
		</Box>
	);
};
